import { getQueryParameter, hrefHasParameter, TestDatabaseConnectionsMode, TestDatabaseConnectionsMessage, ResponseTestDatabaseConnectionsMessage, MenuLayouterParams, AvailableLayoutersMessage, RequestAvailableLayoutersMessage, MulticastDelegate, LayoutUpdatedMessage } from "flavr-common";
import { EndSessionMessage } from "@messages/session/SessionMessages";
import { serverConnection } from "../server/ServerConnectionService";
import { busService } from "@modules/bus/BusService";
import { ModelPath } from "@modules/model/modelPath/ModelPath";
import { getModelFromAbsolutePath } from "@modules/model";
const RESET_SESSION = hrefHasParameter(location.search, "resetSession");
class SessionManagerService {
    constructor() {
        this.availableLayouters = new Map();
        this.layouterNameToId = new Map();
        this.sessionName = "session";
        this.defaultLayouterId = MenuLayouterParams.layouterId;
        this.sessionStarted = false;
        this.startWithoutMenu = false;
        this.onLayoutersUpdatedDelegate = new MulticastDelegate();
        this.isConnectedToSession = false;
        this.sessionIsResetting = false;
        this.wasSessionReset = false;
        this.busConnection = busService.connection("SessionManagerService");
        this.busConnection.subscribe([AvailableLayoutersMessage.typestatic], (msg) => {
            this.handleAvailableLayoutersMessage(msg);
        });
        if (localStorage.getItem("session")) {
            this.lastSessionName = localStorage.getItem("session");
        }
        const locationHref = window.location.href;
        const layout = getQueryParameter(locationHref, "layout");
        if (layout !== undefined && layout !== "") {
            this.defaultLayouterId = layout;
        }
        const initialRoom = getQueryParameter(locationHref, "room");
        // if (initialRoom !== undefined) {
        //   const startRoom = createModelFromPath(initialRoom, undefined, { isStartRoom: true })
        //   this.startRoomUID = startRoom.getUID()
        // }
        if (initialRoom !== undefined && ModelPath.isValid(initialRoom)) {
            const initialRoomModel = getModelFromAbsolutePath(initialRoom);
            if ((initialRoomModel === null || initialRoomModel === void 0 ? void 0 : initialRoomModel.isRoom()) === true) {
                this.startRoomUID = initialRoomModel.getUID();
            }
        }
        const newSession = getQueryParameter(locationHref, "session");
        if (newSession) {
            this.sessionName = newSession;
            localStorage.setItem("session", this.sessionName);
            this.startWithoutMenu = true;
        }
        else if (localStorage.getItem("session")) {
            this.sessionName = localStorage.getItem("session");
        }
        serverConnection.closeDelegate.add(() => {
            this.isConnectedToSession = false;
        });
    }
    init() {
        serverConnection.queueBusMessage(new RequestAvailableLayoutersMessage());
        /* if (this.startWithoutMenu) {
          this.sendClientInfo(this.sessionName);
        } */
        const locationHref = window.location.href;
        const testDb = getQueryParameter(locationHref, "testDb");
        if (testDb) {
            testDb.replace(/\s/g, "");
            const arr = testDb.split(",");
            let mode = TestDatabaseConnectionsMode.MODULAR;
            const testDbMode = getQueryParameter(locationHref, "testDbMode");
            if (testDbMode) {
                if (testDbMode === "random") {
                    mode = TestDatabaseConnectionsMode.RANDOM;
                }
                else if (testDbMode === "modular") {
                    mode = TestDatabaseConnectionsMode.MODULAR;
                }
            }
            let iterations = 100;
            const testDbIterations = getQueryParameter(locationHref, "testDbIteration");
            if (testDbIterations) {
                iterations = Number(testDbIterations) || 0;
            }
            let delay = 0;
            const testDbDelay = getQueryParameter(locationHref, "testDbDelay");
            if (testDbDelay) {
                delay = Number(testDbDelay) || 0;
            }
            this.busConnection.ask(new TestDatabaseConnectionsMessage(arr, mode, iterations, delay), (messages) => {
                const msg = messages.length ? messages[0] : undefined;
                if (msg && ResponseTestDatabaseConnectionsMessage.is(msg)) {
                    for (const data of msg.dbs) {
                        console.log(`[multiplayer] ---Test DB--- name: ${data.db} iterations: ${data.count} failed: ${data.countFailed} error rate: ${(data.countFailed / data.count) * 100}`);
                    }
                }
            });
        }
    }
    handleAvailableLayoutersMessage(msg) {
        if (!AvailableLayoutersMessage.is(msg))
            return;
        for (const layouterId in msg.layouters) {
            const info = msg.layouters[layouterId];
            this.availableLayouters.set(layouterId, info);
            this.layouterNameToId.set(info.name, layouterId);
        }
        this.onLayoutersUpdatedDelegate.invoke();
    }
    resetSession(session) {
        serverConnection.send({
            channel: "session:reset",
            payload: session
        });
    }
    sendClientInfo(sessionName, roomPath, layout) {
        if (this.sessionStarted) {
            this.busConnection.send(new LayoutUpdatedMessage());
            this.busConnection.send(new EndSessionMessage());
        }
        this.sessionStarted = true;
        this.sessionIsResetting = !!(this.currentSessionName && this.currentSessionName === sessionName);
        this.pendingSessionName = sessionName;
        serverConnection.send({
            channel: "clientinfo",
            payload: {
                session: sessionName,
                roomPath,
                resetSession: RESET_SESSION,
                layout
            }
        });
    }
    needsSendSessionInfo() {
        return this.isConnectedToSession || this.startWithoutMenu;
    }
}
export const sessionManagerService = new SessionManagerService();
